angular.module('bb.notifications', []);

require('./listingNotificationSettings.service');
